<h2 mat-dialog-title>
  Select A Service</h2>
<mat-divider></mat-divider>
<mat-dialog-content fxLayout="column">
  <mat-radio-group [(ngModel)]="selectedServiceGroup">
    <mat-radio-button color="primary" style="color:#5A5A5A;width:100%;" *ngFor="let serviceGroup of data.mappedServiceGroups | orderBy: 'name'"
      [value]="serviceGroup.id" fxLayout="row">
      <span class="mat-body-1">{{data.serviceGroups[serviceGroup.id].name}}</span>
      <span class="mat-body-1" *ngIf="data.serviceGroups[serviceGroup.id].serviceGroupRateId && data.serviceGroupRates[data.serviceGroups[serviceGroup.id].serviceGroupRateId].rate">
        ({{data.serviceGroupRates[data.serviceGroups[serviceGroup.id].serviceGroupRateId].rate | currency}})</span>
    </mat-radio-button>
  </mat-radio-group>
</mat-dialog-content>
<mat-divider></mat-divider>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end end" style="margin-right:-8px;padding-bottom:8px;">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button color="primary" (click)="onConfirm(selectedServiceGroup)" [disabled]="!selectedServiceGroup">Select</button>
</div>